import {Button, DataTable, DescriptionList, Modal, LegacyStack, Text, Banner, InlineStack} from "@shopify/polaris";
import {Redirect} from "@shopify/app-bridge/actions";
import {DatePickerModal, toDate} from "../Dates";
import {useCallback, useEffect, useState} from "react";
import Api from "../../helpers/api";
import {useToast} from "@shopify/app-bridge-react";
import {cloneDeep} from "lodash";
import {numberRound} from "../Helpers";

export default ({
    order = null,
    onClose = () => {},
    onOrderSave = () => {},
}) => {
    const redirect = Redirect.create(window.app);
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const closeModal = () => {
        onClose();
    }

    const orderProcessingFormPaymentMethod = () => {
        if (order?.order_processing_form?.payment_method == 'cod_money_order') {
            return [
                { term: 'Payment Method', description: 'COD Money Order' },
            ]
        } else if (order?.order_processing_form?.payment_method == 'distributor') {
            return [
                { term: 'Payment Method', description: 'COD Check' },
            ]
        } else if (order?.order_processing_form?.payment_method == 'credit_card') {
            return [
                { term: 'Payment Method', description: 'Credit Card' },
                { term: 'Last 4', description: order?.order_processing_form?.payment_cc_last_4 },
                { term: 'Exp', description: order?.order_processing_form?.payment_cc_exp_date },
                { term: 'Pre-Auth Amount', description: order?.order_processing_form?.payment_cc_pre_auth_amount },
            ]
        } else if (order?.order_processing_form?.payment_method == 'net') {
            return [
                { term: 'Payment Method', description: 'Net' },
                { term: 'Net', description: order?.order_processing_form?.payment_net },
            ]
        } else if (order?.order_processing_form?.payment_method == 'wire') {
            return [
                { term: 'Payment Method', description: 'Wire' },
                { term: 'Received', description: order?.order_processing_form?.payment_wire_received ? 'YES' : 'NO' },
            ]
        }

        return [];
    }

    return (
        <Modal
            open={!!order}
            title={`Order ${order?.additional_data?.name}`}
            onClose={closeModal}
            primaryAction={{
                content: 'Open in Shopify',
                onAction: () => {
                    redirect.dispatch(Redirect.Action.ADMIN_PATH, {
                        path: `/orders/${order?.additional_data?.id}`,
                        newContext: true,
                    });
                },
            }}
            secondaryActions={[
                {
                    content: "Close",
                    onAction: closeModal,
                }
            ]}
        >
            <Modal.Section>
                <DescriptionList items={[
                    {
                        term: "Shipping Address",
                        description: <DescriptionList items={[
                            {term: "Name", description: `${order?.additional_data?.shipping_address?.first_name ?? ''} ${order?.additional_data?.shipping_address?.last_name ?? ''}`},
                            {term: "Company", description: order?.additional_data?.shipping_address?.company},
                            {term: "Address 1", description: order?.additional_data?.shipping_address?.address1},
                            {term: "Address 2", description: order?.additional_data?.shipping_address?.address2},
                            {term: "City", description: order?.additional_data?.shipping_address?.city},
                            {term: "State", description: order?.additional_data?.shipping_address?.province},
                            {term: "Country", description: order?.additional_data?.shipping_address?.country},
                            {term: "Phone", description: order?.additional_data?.shipping_address?.phone},
                        ]} />
                    },
                    {term: "Shipping Method", description: order?.additional_data?.shipping_lines[0]?.title ?? ''},
                    {term: "Shipping Price", description: `$${order?.additional_data?.shipping_lines[0]?.price ?? '0.00'}`},
                    {term: "Subtotal", description: `$${order?.additional_data?.subtotal_price ?? '0.00'}`},
                    {term: "Tax", description: `$${order?.additional_data?.total_tax ?? '0.00'}`},
                    {term: "Total Discount", description: `$${order?.additional_data?.total_discount ?? '0.00'}`},
                    {term: "Total", description: `$${order?.additional_data?.total_price ?? '0.00'}`},
                ]} />
            </Modal.Section>
            <Modal.Section>
                <Text as={'h1'} variant={"headingLg"}>Line Items</Text>
                <DataTable
                    columnContentTypes={[
                        'text',
                        'text',
                        'text',
                        'text',
                        'text',
                    ]}
                    headings={[
                        "Product",
                        "Sku",
                        "Price",
                        "Quantity",
                        "Total"
                    ]}
                    rows={order?.additional_data?.line_items?.map(item => [
                        item.name,
                        item.sku,
                        `$${item.price}`,
                        item.quantity,
                        `$${numberRound(parseFloat(item.price) * parseFloat(item.quantity))}`,
                    ])}
                />
            </Modal.Section>
        </Modal>
    );
}
